import request from '@/common/request.js'

export function getCMSBanner (data) {
  return request.get('/cms/banner', { params: data })
}

export function getCMSTitleBar (data) {
  return request.get('cms/titleBar/detail', { params: data })
}
